console.log('buy-living.js');

import * as Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {createPinia} from 'pinia';
import DObjectsFilter from '@components/organisms/DObjectsFilter.vue';
import DObjectsMap from '@components/organisms/DObjectsMap.vue';

$(window).on('load', function(e) {

    const url = new URL(location.href);
    const typeParam = url.searchParams.get('type');
    if (!typeParam) {
        url.searchParams.set('type', 'list');
        history.replaceState(null, '', url);
    }

    setViewTypeObjects();
    addEventListener('popstate', setViewTypeObjects);

    function setViewTypeObjects() {
        const url = new URL(location.href);
        const typeParam = url.searchParams.get('type');
        const isMobileTablet = window.matchMedia('(pointer:coarse)').matches && matchMedia('(max-width: 1279px)').matches;
        if (!isMobileTablet) {
            if (typeParam === 'map') {
                document.getElementById('living-app').setAttribute('hidden', 'hidden');
                document.getElementById('living-map-app').removeAttribute('hidden');
                if (window.matchMedia('(max-width: 1279px)').matches) $('header').addClass('_hide');
                tabsWidthStart();
            }
            else {
                document.getElementById('living-map-app').setAttribute('hidden', 'hidden');
                document.getElementById('living-app').removeAttribute('hidden');
                tabsWidthStart();
            }
        }
    }

    document.addEventListener('showMap', () => {
        document.getElementById('living-app').setAttribute('hidden', 'hidden');
        document.getElementById('living-map-app').removeAttribute('hidden');
        if (window.matchMedia('(max-width: 1279px)').matches) $('header').addClass('_hide');
        tabsWidthStart();
    });
    document.addEventListener('showFilter', () => {
        document.getElementById('living-map-app').setAttribute('hidden', 'hidden');
        document.getElementById('living-app').removeAttribute('hidden');
        tabsWidthStart();
    });

    $(document).on('click', '[data-map-point]', function() {
        $('[data-map-point]').removeClass('_active');
        $(this).addClass('_active');
    });

    $(document).on('click', '[data-about-map-point-close]', function() {
        $('[data-map-point]').removeClass('_active');
    });

    try {
        const pinia = createPinia();
        Vue.createApp({components: {DObjectsFilter}}).use(VueAxios, axios).use(pinia).mount('.d-index-flats');
        Vue.createApp({components: {DObjectsMap}}).use(VueAxios, axios).use(pinia).mount('.d-projects__map');
    } catch (e) {
        console.error(e);
    }
});
